/**
 * Created by DSadler on 02/05/2017.
 */
import React, {Component} from 'react';
import * as _ from "lodash";
import StyleItem from "./StyleItem";
import {getContentItems} from "../../state/content/selectors";
import {connect} from "react-redux";
import cheerio from 'cheerio';

class TocItem extends Component {
  render() {
    // Construct links
    let links = this.props.headers.map((item, key, array) => {
      let element = cheerio.load(item.contentContent);
      return (
        <p key={item.contentId}>
          <a
            href={"#" + item.contentId}
          >{element.text()}
          </a>
          {key < array.length - 1 && <br/>}
        </p>
      );
    });
    
    return (
      <td
        id={this.props.contentId}
        className={[this.props.contentId, this.props.viewClass,].join(" ").trim()}
        ref={(node) => {
          _.toPairs(this.props.viewAttributes).map((item) => {
            return node && node.setAttribute(item[0], item[1]);
          });
        }}
        {...this.props.eventHandlers}
        style={{
          width: this.props.styleWidth,
          height: this.props.styleHeight,
          padding: this.props.stylePadding,
          backgroundColor: this.props.styleBackgroundColour,
          color: this.props.styleTextColour,
          textAlign: this.props.styleTextAlignment,
        }}
      >
        <StyleItem selectorPrefix={this.props.contentId + " "} styleObject={this.props.viewCss}/>
        {links.map((item) => item)}
      </td>
    );
  }
}

function mapStateToProps(state, ownprops) {
  return {
    ...ownprops,
    headers: getContentItems(state, {configId: "SECTION_HEADER"}),
  }
}

export default connect(mapStateToProps)(TocItem);


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/TocItem.js